<template>
  <div class="flex flex-col gap-9 max-w-[360px] md:max-w-[390px] mx-auto">
    <div class="text-center">
      <PageHeaderLogo />
    </div>

    <PreResetCredentialsData v-if="status === 'PreReset'" v-model:data="preLoginData" @next="onPreResetNextClick" />

    <OtpResetCredentialsData
      v-if="status === 'Otp'"
      v-model:data="otpData"
      v-model:method="otpMethod"
      @back="onOtpBackClick"
      @next="onOtpResetNextClick"
    />

    <ResetCredentialsData v-if="status === 'Reset'" @back="onResetBackClick" @next="onResetNextClick" />

    <SuccessResetCredentialsData v-if="status === 'Success'" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useTranslation } from "i18next-vue";
import { useHeadSafe } from "@unhead/vue";
import { storeToRefs } from "pinia";
import {
  OtpResetCredentialsResponseType,
  OtpResetCredentialsType,
  PreResetCredentialsType,
  ResetCredentialsStatusType,
} from "@authentication/types";
import { useUiStore } from "@common/stores";
import {
  OtpResetCredentialsData,
  PageHeaderLogo,
  PreResetCredentialsData,
  ResetCredentialsData,
  SuccessResetCredentialsData,
} from "@authentication/ui";

// Variables
const { t } = useTranslation();
const { realm } = storeToRefs(useUiStore());
const otpData = ref<OtpResetCredentialsType>({
  username: "",
  email: "",
  otp: "",
});
const otpMethod = ref<OtpResetCredentialsResponseType>({
  hint: "",
  method: "E-OTP",
  timeout: 0,
});
const preLoginData = ref<PreResetCredentialsType>({
  username: "",
  email: "",
});
const status = ref<ResetCredentialsStatusType>("Otp");

// Strings
const pageTitleString = t("reset_credentials.page_title", { realmName: realm.value.name });

// Methods
const onOtpBackClick = () => {
  status.value = "PreReset";
};

const onPreResetNextClick = (method: OtpResetCredentialsResponseType) => {
  otpData.value.email = preLoginData.value.email;
  otpData.value.username = preLoginData.value.username;
  otpMethod.value = method;
  status.value = "Otp";
};

const onOtpResetNextClick = () => {
  status.value = "Reset";
};

const onResetBackClick = () => {
  status.value = "PreReset";
  otpData.value.otp = "";
};

const onResetNextClick = () => {
  status.value = "Success";
};

// Hooks
useHeadSafe({
  title: pageTitleString,
});
</script>
